import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Image,
  Input,
  Pagination,
  Row,
  Segmented,
  Slider,
  Space,
  Spin,
  Switch,
  Tag,
  Typography,
} from "../../../components/common/utils/antd-imports/AntdImports.js";
import LocationIcon from "../../../assests/location-Icon.svg";
import FilterSvg from "../../../assests/Filter.svg";
import { ReactComponent as SelectUpIcon } from "../../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../../../assests/select-down-icon.svg";
import { ReactComponent as SearchIcon } from "../../../assests/search-icon.svg";
import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./ProductsPage.css";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  AppstoreOutlined,
  BarsOutlined,
  CloseOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  DesktopProductCard,
  MobileProductCard,
} from "../../common/products/ProductCard";
import GoogleMapsComponent from "../../common/map-view/GoogleMapsComponent";
import FilterDrawer from "../../common/filter-drawer/FilterDrawer";
import LocationsList from "../../common/locationlistpopover/LocationList";
import { debounce } from "lodash";
import { ReactComponent as CalenderIcon } from "../../../assests/cuida_calendar-outline.svg";
import ProductFilters from "../../common/product-filters/ProductFilters";
import { getFilterProducts } from "../../../store/thunks/common-thunks/commonThunk";
import {
  clearSelectedDMAs,
  setSelectedDMAs,
} from "../../../store/thunks/common-thunks/Actions";
import ViewMoreFilter from "../../common/view-more-filters/ViewMoreFilter";
import {
  setSearchText,
  setSelectedSizes,
  setDateRange,
  setInComeSliderValue,
  setFilterChecks,
  setFilters,
  setMapView,
  setPagination,
  clearAllFilters as clearAllProductFilters,
  setShowNearby,
  clearSelectedState,
  clearUserInteracted,
  clearMapCamera,
  setFiltersApplied,
  clearAllFiltersApllied,
  setShapeOfMap,
  clearSelectedStateId,
  setViewType,
  setProductTypes,
} from "../../../store/slices/common-slice/product-filters/ProductFilter";
import dayjs from "dayjs";
import qs from "query-string";
import "../../../main.css";
import BreadcrumbNav from "../../common/bread-crumbs/BreadCrumb";
import WidthAwareTooltip from "../../common/custom-tooltip/customTooltip.js";
import AdPlacement from "../../../features/Ads/adPlacement/adPlacement.js";
import EmptyViewCard from "../../common/empty-view-card/EmptyViewCard.js";
import "./products-grid-view/ProductGridCard.css";
import ProductGridCard from "./products-grid-view/ProductGridCard.js";
import ReusableModal from "../../modal/re-usable-modal/ReusableModal.js";
import LoginAlert from "../../modal/login-alert/LoginAlert.js";
const { Text } = Typography;
const { Panel } = Collapse;

const ProductPage = () => {
  // Redux and state
  const dmaClearRef = useRef(null);
  const {
    isLoading,
    filterProducts,
    channelData,
    sizeList,
    maxPrice,
    minPrice,
    maxDate,
    locationList,
  } = useSelector((state) => state.products);
  const {
    selectedDateRange,
    searchText,
    selectedSizes,
    inComeSliderValue,
    filterChecks,
    filters,
    mapView,
    showNearby,
    pageNum,
    userInteracted,
    filterApplied,
  } = useSelector((state) => state.filters);
  const viewType = useSelector((state) => state.filters?.viewType ?? "kanban");
  const selectedDMAs = useSelector((state) => state.dma.selectedDMAs);
  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [mapPinPointers, setMapPinPointers] = useState([]);
  // Individual search for each product type
  const [searchProductTypeByTitle, setSearchProductTypeByTitle] = useState({});
  const [drawVisible, setDrawerVisible] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("");
  const [selectedProductId, setSelectedProductId] = useState(null);
  // Remove local mapView state, use Redux instead
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [expandedPanels, setExpandedPanels] = useState({});
  const [allFetchedProducts, setAllFetchedProducts] = useState([]);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });
  const [productMsg, setProductsMsg] = useState("");
  const containerRef = useRef(null);
  const filterDrawerRef = useRef(null);
  const products_total_count =
    filterProducts?.filter_data?.products_total_count;
  const map_pins_count = filterProducts?.filter_data?.map_pins_count;
  // Debounced fetch for searchText
  const searchDidMountRef = useRef(false);
  const didMountRef = useRef(false);
  const productsCount = useRef(0);
  // Fetch on showNearby toggle (send empty price values)
  const showNearbyDidMountRef = useRef(false);
  const pendingNearbyFetchRef = useRef(false);
  const [isViewFilter, setIsViewFilter] = useState(false);
  // Routing and responsive
  const navigate = useNavigate();
  const isTab = useMediaQuery({ maxWidth: 1199 });
  const isTab1 = useMediaQuery({ maxWidth: 768 });
  const [stateSelected, setStateSelected] = useState(() => {
    return localStorage.getItem("STATE_SELECTED") === "true";
  });
  const [isBulkCampaignModalOpen, setIsBulkCampaignModalOpen] = useState(false);
  const itemsPerPage = 8;
  const [searchInput, setSearchInput] = useState(searchText || "");
  // --- Parse and flatten filters: always derive items from filterChecks ---
  const [lastProductFilterPayload, setLastProductFilterPayload] =
    useState(null);
  const captureProductFilterPayload = useCallback((payload) => {
    setLastProductFilterPayload(payload ? { ...payload } : null);
  }, []);
  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const parseAndFlatten = useCallback((filtersObj) => {
    const result = [];
    for (const key in filtersObj) {
      const value = filtersObj[key];
      if (Array.isArray(value)) {
        value.forEach((item) => {
          try {
            result.push({ ...JSON.parse(item), title: key });
          } catch (e) {
            result.push({
              ...(typeof item === "object" ? item : { label: item }),
              title: key,
            });
          }
        });
      } else {
        try {
          result.push({ ...JSON.parse(value), title: key });
        } catch (e) {
          result.push({
            ...(typeof value === "object" ? value : { label: value }),
            title: key,
          });
        }
      }
    }
    return result;
  }, []);
  const items = useMemo(
    () => parseAndFlatten(filterChecks),
    [filterChecks, parseAndFlatten],
  );
  const skipFirstUrlSync = useRef(true);
  // Memoized values
  const dmaIds = useMemo(() => {
    // this is added for the not getting the
    if (!Array.isArray(selectedDMAs)) return [];
    return selectedDMAs.map((item) => item?.id).filter(Boolean);
  }, [selectedDMAs]);
  const productTypeIds = useMemo(
    () =>
      Array.isArray(items)
        ? items?.map((item) => item?.id).filter(Boolean)
        : [],
    [items],
  );

  // Geolocation
  const getGeolocationDetails = useCallback((callback) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            error: null,
          });
          if (callback)
            callback(position.coords.latitude, position.coords.longitude);
        },
        (error) => {
          setLocation({
            latitude: null,
            longitude: null,
            error: error.message,
          });
          if (callback) callback(null, null);
        },
      );
    } else {
      setLocation({
        latitude: null,
        longitude: null,
        error: "Geolocation not supported by this browser.",
      });
      if (callback) callback(null, null);
    }
  }, []);

  const getAddressFromCoordinates = useCallback(async () => {
    const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
    const waitForLocation = async (retries = 5, delay = 1000) => {
      for (let i = 0; i < retries; i++) {
        if (location.latitude && location.longitude) break;
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    };
    await waitForLocation();
    if (!location.latitude || !location.longitude) return;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location?.latitude},${location?.longitude}&key=${API_KEY}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === "OK") {
        setCurrentLocation(data.results[0].formatted_address);
      }
    } catch (error) {
      // Optionally handle error
    }
  }, [location?.latitude, location?.longitude]);

  const handleGetLocationAndAddress = useCallback(() => {
    getGeolocationDetails(() => getAddressFromCoordinates());
  }, [getGeolocationDetails, getAddressFromCoordinates]);

  // Handlers
  const handleProductSelect = useCallback(
    (productId) => setSelectedProductId(productId),
    [],
  );
  const handleInComeSliderChange = useCallback(
    (value) => {
      dispatch(setInComeSliderValue(value));
    },
    [dispatch],
  );
  const handleNearbyProducts = useCallback(() => {
    pendingNearbyFetchRef.current = true;
    dispatch(setShowNearby(!showNearby));
    if (showNearby) {
      dispatch(clearUserInteracted(null));
    }
  }, [dispatch, showNearby]);
  const handleIncomeInputChange = useCallback(
    (index, e) => {
      const newValue = [...inComeSliderValue];
      newValue[index] = Number(e.target.value) || "";
      dispatch(setInComeSliderValue(newValue));
    },
    [dispatch, inComeSliderValue],
  );
  const handleDateChange = useCallback(
    (dates) => {
      dispatch(setInComeSliderValue(["", ""]));
      dispatch(
        setDateRange({
          from: dates?.[0] ? dayjs(dates[0]).toISOString() : null,
          to: dates?.[1] ? dayjs(dates[1]).toISOString() : null,
        }),
      );
    },
    [dispatch],
  );
  const handleViewMore = useCallback(
    (title) =>
      setExpandedPanels((prev) => ({ ...prev, [title]: !prev[title] })),
    [],
  );
  const handleTextChange = useCallback(
    (value) =>
      value ? value.replace(value[0], value[0].toUpperCase()) : value,
    [],
  );
  const handleSearchTextChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  const debouncedUpdateSearch = useMemo(
    () =>
      debounce((value) => {
        dispatch(setSearchText(value));
      }, 1000),
    [dispatch],
  );

  useEffect(() => {
    debouncedUpdateSearch(searchInput);
    return () => debouncedUpdateSearch.cancel();
  }, [searchInput]);
  //updated searchInput whenever searchText changes
  useEffect(() => {
    setSearchInput(searchText);
  }, [searchText]);

  const handleSelectedSizesChange = useCallback(
    (sizes) => {
      dispatch(setFiltersApplied(true));
      dispatch(setSelectedSizes(sizes));
    },
    [dispatch],
  );
  // Remove tag handler
  const handleClose = useCallback(
    (itemToRemove) => {
      if (itemToRemove.title) {
        // Remove from Redux filters
        const updated = {
          ...filters,
          [itemToRemove.title]: filters[itemToRemove?.title]?.filter((val) => {
            try {
              const parsed = typeof val === "string" ? JSON.parse(val) : val;
              return !(
                parsed?.id === itemToRemove?.id &&
                parsed?.label === itemToRemove?.label
              );
            } catch (e) {
              return val !== itemToRemove?.label;
            }
          }),
        };
        dispatch(setFilterChecks(updated));
        dispatch(clearAllFiltersApllied());
      } else {
        const updatedDMAs = selectedDMAs?.filter(
          (dma) => dma?.id !== itemToRemove?.id,
        );
        dispatch(setSelectedDMAs(updatedDMAs));
      }
    },
    [filters, selectedDMAs, dispatch],
  );

  // Tag rendering
  const tags = useMemo(() => {
    const combinedTags = [
      ...(items || []),
      ...(showNearby ? [] : selectedDMAs || []),
    ];
    const visibleTags = combinedTags.slice(0, 8);
    const hiddenCount = combinedTags.length - visibleTags.length;
    return (
      <div className="filter-tags">
        {visibleTags?.map((item, index) => (
          <Tag
            key={`${item.title || "dma"}-${item.id ?? item.label}-${index}`}
            closable
            onClose={() => handleClose(item)}
            closeIcon={<CloseOutlined />}
            color="#d2042d"
          >
            {typeof item.label === "string" || typeof item?.label === "number"
              ? item?.label
              : "Unknown"}
          </Tag>
        ))}
        {hiddenCount > 0 && (
          <Text
            className="extra-tag-display"
            onClick={() => {
              setIsViewFilter(true);
            }}
          >
            +{hiddenCount} more
          </Text>
        )}
      </div>
    );
  }, [items, selectedDMAs, showNearby, handleClose]);

  // Clear all filters
  const clearDmaFilters = useCallback(() => {
    if (dmaClearRef.current) dmaClearRef.current();
  }, []);
  const isHydratedRef = useRef(false);
  const hydrationCompletedRef = useRef(false);
  const handleClearAll = useCallback(() => {
    clearDmaFilters();
    dispatch(clearAllProductFilters());
    dispatch(setSearchText(""));
    dispatch(clearSelectedDMAs());
    localStorage.removeItem("searchLocationAddress");
    localStorage.removeItem("STATE_SELECTED");
    dispatch(setFiltersApplied(false));
    dispatch(clearAllFiltersApllied(false));
    dispatch(clearSelectedState());
    dispatch(clearUserInteracted());
    dispatch(clearMapCamera());
    dispatch(setMapView(false));
    dispatch(clearSelectedStateId());
    dispatch(setShapeOfMap());
    sessionStorage.removeItem("PAGINATION_ACTIVE");
    sessionStorage.removeItem("mapZoomVal");
  }, [clearDmaFilters, dispatch]);
  const products =
    filterProducts?.products?.length > 0 ? filterProducts.products : [];

  // Filter counts
  const getFilterCounts = useCallback(() => {
    let filterCount = 0;
    let subCount = 0;

    for (const key in filters) filterCount += filters[key]?.length || 0;
    subCount = Object.entries(filters).map(([key, arr]) => ({
      key,
      count: arr.length,
    }));
    const dmaCount = selectedDMAs?.length || 0;
    return { filterCount, dmaCount, total: filterCount + dmaCount };
  }, [filters, selectedDMAs]);
  const { filterCount, dmaCount, total } = getFilterCounts();
  // Fetch products
  const handleFetchProducts = useCallback(
    (
      page,
      isPagination = false,
      customPageSize,
      overrideSearchText = null,
      options = {},
    ) => {
      if (isLoading) return;
      const isMobile = window.innerWidth <= 769;
      const pageNumber = isMobile ? page || 1 : page || pageNum || 1;
      const pageSize = customPageSize || (isMobile ? 8 : itemsPerPage);
      // If this is a pagination call, send price values; otherwise, send empty strings
      // Special case: if searchText is non-empty and not paginating, always send empty strings for price

      const effectiveSearchText =
        overrideSearchText !== null ? overrideSearchText : searchText;
      const selectedDMAsLength = Array.isArray(selectedDMAs)
        ? selectedDMAs.length
        : 0;
      const itemsLength = Array.isArray(items) ? items.length : 0;
      const isSearch = !!effectiveSearchText?.trim();
      const shouldSendPrices =
        isPagination ||
        (!selectedDMAsLength &&
          !selectedSizes?.length &&
          !effectiveSearchText &&
          !itemsLength);

      const sendEmptyPrices = isSearch && !isPagination;
      const hasDate = !!(
        selectedDateRange &&
        (selectedDateRange.from || selectedDateRange.to)
      );

      if (hasDate) {
        dispatch(setFiltersApplied(hasDate));
      }
      const ignorePriceIfDma = options.ignorePriceIfDma;
      const overrideDmaIds = options.overrideDmaIds;
      const finalDmaIds =
        overrideDmaIds !== undefined ? overrideDmaIds : dmaIds;
      const finalDateRange = options?.overrideDateRange;
      const payload = showNearby
        ? {
            product_type: productTypeIds,
            product_fromPrice:
              sendEmptyPrices || ignorePriceIfDma
                ? ""
                : shouldSendPrices && inComeSliderValue?.[0] !== null
                  ? String(inComeSliderValue[0])
                  : "",
            product_toPrice:
              sendEmptyPrices || ignorePriceIfDma
                ? ""
                : shouldSendPrices && inComeSliderValue?.[1] !== null
                  ? String(inComeSliderValue[1])
                  : "",
            booked_from:
              selectedDateRange?.from?.format?.("YYYY-MM-DD") ||
              selectedDateRange?.from ||
              "",
            booked_to:
              selectedDateRange?.to?.format?.("YYYY-MM-DD") ||
              selectedDateRange?.to ||
              "",
            size: selectedSizes || [],
            search_param: effectiveSearchText,
            radiusSearch: {
              latitude: location?.latitude || 34.05,
              longitude: location?.longitude || -118.25,
              radius: 5,
            },
            product_dma: [],
            page_no: "",
            page_size: "",
          }
        : {
            page_no: pageNumber || 1,
            page_size: pageSize,
            product_type: productTypeIds,
            product_fromPrice: sendEmptyPrices
              ? ""
              : shouldSendPrices &&
                  inComeSliderValue?.[0] != null &&
                  inComeSliderValue?.[1] != null &&
                  !(
                    Number(inComeSliderValue[0]) === 0 &&
                    Number(inComeSliderValue[1]) === 0
                  ) &&
                  Number(inComeSliderValue[0]) > 0
                ? String(inComeSliderValue[0])
                : "",

            product_toPrice: sendEmptyPrices
              ? ""
              : shouldSendPrices &&
                  inComeSliderValue?.[0] != null &&
                  inComeSliderValue?.[1] != null &&
                  !(
                    Number(inComeSliderValue[0]) === 0 &&
                    Number(inComeSliderValue[1]) === 0
                  ) &&
                  Number(inComeSliderValue[1]) > 0
                ? String(inComeSliderValue[1])
                : "",
            booked_from:
              selectedDateRange?.from?.format?.("YYYY-MM-DD") ||
              selectedDateRange?.from ||
              finalDateRange?.from?.format?.("YYYY-MM-DD") ||
              finalDateRange?.from ||
              "",
            booked_to:
              selectedDateRange?.to?.format?.("YYYY-MM-DD") ||
              selectedDateRange?.to ||
              finalDateRange?.to?.format?.("YYYY-MM-DD") ||
              finalDateRange?.to ||
              "",
            size: selectedSizes || [],
            search_param: effectiveSearchText,
            product_dma: finalDmaIds,
          };
      captureProductFilterPayload(payload);
      if (!mapView || showNearby) {
        dispatch(getFilterProducts(payload));
      } else if (mapView && !showNearby) {
        dispatch(getFilterProducts(payload));
      }

      if (!isMobile)
        navigate(
          {
            search: qs.stringify({
              ...qs.parse(window.location.search),
              page: pageNumber,
            }),
          },
          { replace: true },
        );
      dispatch(setPagination(pageNumber));
    },
    [
      isLoading,
      showNearby,
      productTypeIds,
      inComeSliderValue,
      selectedDateRange,
      selectedSizes,
      searchText,
      dmaIds,
      dispatch,
      navigate,
      pageNum,
      selectedDMAs.length,
      items.length,
      itemsPerPage,
    ],
  );

  // Debounced fetch for searchText
  const debouncedFetchProducts = useMemo(
    () => debounce(() => handleFetchProducts(1, false), 1000),
    [handleFetchProducts],
  );
  const hasUrlPrice = useMemo(() => {
    const parsed = qs.parse(window.location.search);
    return !!parsed.price;
  }, []);

  const parsedQuery = useMemo(() => {
    return qs.parse(location.search);
  }, [location.search]);

  const hasUrlDmas = !!parsedQuery.dmas;
  useEffect(() => {
    if (!isHydratedRef.current) return;
    if (hasUrlPrice) return;
    const INITIAL_INCOME_RANGE = [0, 4554543];
    const isSearchActive = !!searchText?.trim();
    if (isSearchActive) return;
    const isSliderInitial =
      Array.isArray(inComeSliderValue) &&
      Number(inComeSliderValue[0]) === INITIAL_INCOME_RANGE[0] &&
      Number(inComeSliderValue[1]) === INITIAL_INCOME_RANGE[1];

    if (!stateSelected && !hasUrlDmas) {
      if (minPrice != null && maxPrice != null) {
        dispatch(setInComeSliderValue([minPrice, maxPrice]));
      }
      return;
    }
    // State selected + DMA exists
    if (
      Array.isArray(selectedDMAs) &&
      selectedDMAs.length > 0 &&
      !isSliderInitial
    ) {
      dispatch(setInComeSliderValue([0, 600000]));
      return;
    }
    // State selected + no DMA
    const isBackendInvalid = !maxPrice || Number(maxPrice) === 0;
    if (stateSelected && !isBackendInvalid) {
      dispatch(
        setInComeSliderValue([
          Number(minPrice) || INITIAL_INCOME_RANGE[0],
          Number(maxPrice) || INITIAL_INCOME_RANGE[1],
        ]),
      );
    }
  }, [
    stateSelected,
    selectedDMAs,
    minPrice,
    maxPrice,
    searchText,
    hasUrlPrice,
    dispatch,
  ]);

  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!searchDidMountRef.current) {
      searchDidMountRef.current = true;
      if (!searchText) return;
    }
    debouncedFetchProducts();
    return () => debouncedFetchProducts.cancel();
  }, [searchText]);

  // setting the map pin pointers
  useEffect(() => {
    if (filterProducts) {
      setMapPinPointers(filterProducts?.map_pin_pointers);
    }
  }, [filterProducts]);
  // Fetch on filter changes (send empty price values)
  useEffect(() => {
    // Here blocking the api until the hydration completed
    if (!hydrationCompletedRef.current) return;

    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    if (window.innerWidth <= 1199 || mapView) return;
    handleFetchProducts(1, false);
    setAllFetchedProducts([]);
  }, [selectedDMAs, selectedSizes, items]);

  // Fetch on pagination (send price values)
  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (window.innerWidth <= 769 || mapView) return;
    handleFetchProducts(pageNum, true);
    setAllFetchedProducts([]);
  }, [pageNum]);

  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!showNearbyDidMountRef.current) {
      showNearbyDidMountRef.current = true;
      return;
    }
    if (!pendingNearbyFetchRef.current) return;
    if (window.innerWidth <= 769) return;
    if (isLoading) return;
    pendingNearbyFetchRef.current = false;
    handleFetchProducts(1, false);
    setAllFetchedProducts([]);
  }, [showNearby, isLoading, handleFetchProducts]);

  const handleFiltersApplied = () => {
    setIsLoadMore(false);

    // Scroll to top
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = node;
      if (scrollTop + clientHeight >= scrollHeight - 30) {
        if (
          window.innerWidth <= 769 &&
          filterDrawerRef.current?.loadMoreProducts
        ) {
          setIsLoadMore(true);
          filterDrawerRef.current.loadMoreProducts();
        }
      }
    };
    node.addEventListener("scroll", handleScroll);
    return () => node.removeEventListener("scroll", handleScroll);

    // Re-attach when container, mapView, or isTab1 changes
  }, [containerRef.current, mapView, isTab1]);

  useEffect(() => {
    const finalProductsList = filterProducts?.products ?? [];
    let newProducts = [];
    if (Array.isArray(finalProductsList)) {
      newProducts = finalProductsList.flatMap((item) => item || []);
    }

    handleGetLocationAndAddress();

    const newProductsCount = Array.isArray(filterProducts?.products)
      ? filterProducts?.products?.map((item) => item.products_total_count)
      : [];

    const prevProductsCount = productsCount.current;
    const isCountChanged =
      JSON.stringify(prevProductsCount) !== JSON.stringify(newProductsCount);

    setAllFetchedProducts((prev) => {
      if (isLoadMore) {
        // Always append on load more
        const mergedProducts = [...prev, ...newProducts];
        const uniqueProducts = Array.from(
          new Set(mergedProducts?.map((p) => p?.product_details?.[0]?.id)),
        )?.map((id) =>
          mergedProducts?.find((p) => p?.product_details?.[0]?.id === id),
        );
        return uniqueProducts;
      } else if (isCountChanged) {
        // If product count changed, replace

        const uniqueProducts = Array.from(
          new Set(newProducts?.map((p) => p?.product_details?.[0]?.id)),
        )?.map((id) =>
          newProducts?.find((p) => p?.product_details?.[0]?.id === id),
        );
        return uniqueProducts;
      } else {
        // Otherwise, append
        const uniqueProducts = Array.from(
          new Set(newProducts?.map((p) => p?.product_details?.[0]?.id)),
        )?.map((id) =>
          newProducts.find((p) => p?.product_details?.[0]?.id === id),
        );
        return uniqueProducts;
      }
    });

    productsCount.current = newProductsCount;
    setIsLoadMore(false); // Reset after update
  }, [
    filterProducts?.products,
    filterProducts?.products?.[0]?.products_total_count,
  ]);

  // Map view modal logic
  const handleMapView = useCallback(() => {
    dispatch(setMapView(!mapView));
    dispatch(clearUserInteracted());
  }, [mapView, dispatch]);

  // --- Fix: Sync filterChecks to filters for correct checked state and tag rendering ---
  // Add a useEffect to always sync filterChecks to filters
  useEffect(() => {
    dispatch(setFilters(filterChecks));
  }, [filterChecks, dispatch]);

  // --- Sync filters and pagination to URL query params ---
  useEffect(() => {
    if (!hydrationCompletedRef.current) return;
    if (!isHydratedRef.current) {
      return;
    }
    if (skipFirstUrlSync.current) {
      skipFirstUrlSync.current = false;
      return;
    }
    const params = {
      sizes: selectedSizes?.length ? selectedSizes.join(",") : undefined,
      types:
        items
          ?.filter(
            (i) =>
              i.title !== "Size" &&
              i.title !== "sizes" &&
              i.title !== "DMA" &&
              i.title !== "dmas",
          )
          .map((i) => i.id)
          .join(",") || undefined,
      dmas: selectedDMAs?.map((d) => d.id).join(",") || undefined,
      price: inComeSliderValue ? inComeSliderValue.join(",") : undefined,
      from:
        selectedDateRange?.from?.format?.("YYYY-MM-DD") ||
        selectedDateRange?.from ||
        undefined,
      to:
        selectedDateRange?.to?.format?.("YYYY-MM-DD") ||
        selectedDateRange?.to ||
        undefined,
      search: searchText || undefined,
      page: pageNum !== 1 ? pageNum : undefined,
      pageSize: itemsPerPage !== 8 ? itemsPerPage : undefined,
      mapView: mapView ? 1 : undefined,
      showNearby: showNearby ? 1 : undefined,
      viewType: viewType !== "kanban" ? viewType : "kanban",
    };
    Object?.keys(params)?.forEach(
      (k) => params[k] === undefined && delete params[k],
    );

    const query = qs?.stringify(params);
    navigate({ search: query ? `?${query}` : "" }, { replace: true });
    // eslint-disable-next-line
  }, [
    items,
    selectedDMAs,
    inComeSliderValue,
    selectedSizes,
    selectedDateRange,
    searchText,
    pageNum,
    itemsPerPage,
    mapView,
    viewType,
  ]);
  const isFiltersApplied = useMemo(() => {
    const hasDMA = selectedDMAs?.length > 0;
    const hasSearchText = !!searchText?.trim();
    const hasOtherFilters = Object.values(filterChecks || {}).some(
      (arr) => Array.isArray(arr) && arr.length > 0,
    );

    const hasSizes = selectedSizes?.length > 0;

    return hasDMA || hasOtherFilters || hasSizes || hasSearchText;
  }, [selectedDMAs, filterChecks, inComeSliderValue, selectedSizes]);
  useEffect(() => {
    dispatch(setFiltersApplied(isFiltersApplied));
  }, [isFiltersApplied, dispatch]);
  //Getting the selected dmas from url
  useEffect(() => {
    if (!locationList?.length) return;

    const parsed = qs.parse(window.location.search);
    if (!parsed.dmas) return;

    const urlDmaIds = parsed.dmas.split(",");

    const restoredDmas = urlDmaIds
      ?.map((id) => {
        const found = locationList?.find(
          (loc) => String(loc.id) === String(id),
        );
        return found ? { id: found.id, label: found.city_name } : null;
      })
      ?.filter(Boolean);

    // Prevent infinite loop
    const currentIds = selectedDMAs?.map((d) => String(d.id)).sort();
    const restoredIds = restoredDmas?.map((d) => String(d.id)).sort();

    const isSame = JSON.stringify(currentIds) === JSON.stringify(restoredIds);

    if (!isSame) {
      dispatch(setSelectedDMAs(restoredDmas));
    }
  }, [locationList]);
  // Product Type
  useEffect(() => {
    if (!channelData?.length) return;
    if (!hydrationCompletedRef.current) return;
    const parsed = qs.parse(window.location.search);
    if (!parsed.types) return;

    const urlTypeIds = parsed.types.split(",");

    // Flatten all type options
    const allTypeOptions = channelData.flatMap((c) => c.filter);

    const restoredTypes = urlTypeIds
      ?.map((id) => {
        const found = allTypeOptions?.find(
          (opt) => String(opt?.id) === String(id),
        );
        return found ? { id: found?.id, label: found?.label } : null;
      })
      ?.filter(Boolean);

    // Build new filterChecks structure
    const updatedFilterChecks = {};

    channelData.forEach((channel) => {
      const matched = restoredTypes?.filter((type) =>
        channel?.filter.some((opt) => String(opt.id) === String(type.id)),
      );

      if (matched.length > 0) {
        updatedFilterChecks[channel.title] = matched?.map((type) =>
          JSON.stringify(type),
        );
      }
    });

    // Prevent infinite loop
    const isSame =
      JSON.stringify(filterChecks) === JSON.stringify(updatedFilterChecks);

    if (!isSame) {
      dispatch(setFilterChecks(updatedFilterChecks));
    }
  }, [channelData, filterChecks]);
  //for the sizes
  useEffect(() => {
    if (!sizeList?.length) return;
    const parsed = qs.parse(window.location.search);
    if (!parsed.sizes) return;
    const urlSizes = parsed.sizes.split(",");
    // Only keep valid sizes from available list
    const validSizes = urlSizes.filter((size) =>
      sizeList.some((item) => handleTextChange(item.label) === size),
    );
    //  Prevent infinite loop
    const isSame =
      JSON.stringify([...validSizes].sort()) ===
      JSON.stringify([...(selectedSizes || [])].sort());

    if (!isSame) {
      dispatch(setSelectedSizes(validSizes));
    }
  }, [sizeList, selectedSizes]);

  // --- Hydrate filters and pagination from URL on mount ---
  useEffect(() => {
    // clearing the previous states
    dispatch(clearAllProductFilters());
    //dispatch(clearSelectedDMAs()); //Commented to prevent DMA reset issue when clicking cities multiple times from homepage
    dispatch(setSearchText(""));
    dispatch(setSelectedSizes([]));
    dispatch(setProductTypes([]));
    dispatch(setDateRange({ from: null, to: null }));
    const parsed = qs.parse(window.location.search);
    const urlDmaIds = parsed.dmas ? parsed.dmas.split(",") : [];
    const hasUrlDmas = urlDmaIds.length > 0;
    if (parsed.sizes) dispatch(setSelectedSizes(parsed.sizes.split(",")));

    // Restore product types with labels
    if (parsed.types && channelData) {
      const typeIds = parsed.types.split(",");
      const allTypeOptions = channelData.flatMap((c) => c.filter);
      const typeArr = typeIds.map((id) => {
        const found = allTypeOptions.find(
          (opt) => String(opt.id) === String(id),
        );
        return found ? { id: found.id, label: found.label } : { id };
      });
      // Update filterChecks for the correct channel title(s)
      const updatedFilterChecks = { ...filterChecks };
      channelData.forEach((channel) => {
        const channelTypeArr = typeArr.filter((type) => {
          return channel.filter.some(
            (opt) => String(opt.id) === String(type.id),
          );
        });
        if (channelTypeArr.length > 0) {
          updatedFilterChecks[channel.title] = channelTypeArr.map((type) =>
            JSON.stringify(type),
          );
        }
      });
      dispatch(setFilterChecks(updatedFilterChecks));
    }
    if (parsed.price) {
      const [min, max] = parsed.price.split(",").map(Number);
      dispatch(setInComeSliderValue([min, max]));
    }
    if (parsed.from || parsed.to) {
      dispatch(
        setDateRange({
          from: parsed.from ? dayjs(parsed.from).toISOString() : null,
          to: parsed.to ? dayjs(parsed.to).toISOString() : null,
        }),
      );
    }
    if (parsed.search) {
      dispatch(setSearchText(parsed.search));
      searchDidMountRef.current = true;
    }
    // Restore mapView state from URL
    if (parsed.mapView !== undefined) {
      dispatch(
        setMapView(
          parsed.mapView === "1" ||
            parsed.mapView === 1 ||
            parsed.mapView === true ||
            parsed.mapView === "true",
        ),
      );
    } else {
      dispatch(setMapView(false));
    }
    if (parsed.viewType) {
      dispatch(setViewType(parsed.viewType));
    }
    // Pagination: if no page param, set to 1 and update URL
    const page = parsed.page ? parseInt(parsed.page) : 1;
    const pageSize = parsed.pageSize ? parseInt(parsed.pageSize) : 8;
    dispatch(setPagination(page));
    if (!parsed.page) {
      // Update URL to include page=1 (or remove for clean URL)
      const params = { ...parsed, page: 1 };
      const query = qs.stringify(params);
    }
    isHydratedRef.current = true;
    hydrationCompletedRef.current = true;
    handleFetchProducts(page, false, pageSize, parsed.search || "", {
      ignorePriceIfDma: hasUrlDmas,
      overrideDmaIds: urlDmaIds,
      overrideDateRange: {
        from: parsed.from || null,
        to: parsed.to || null,
      },
    });
  }, []);

  const filteredLocationList = locationList?.filter(({ city_name }) =>
    city_name.toLowerCase().includes(searchKeyword.toLowerCase()),
  );
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const handleInstantCampaign = () => {
    if (!isLoggedIn) {
      sessionStorage.setItem("returnToShopMapView", "true");
      setLoginPopoverVisible(true);
    } else {
      setIsBulkCampaignModalOpen(true);
    }
  };

  // UI
  return (
    <>
      <div className="product-page">
        <Row className="product-page-container">
          <Col
            xl={12}
            lg={12}
            md={isTab ? 15 : 12}
            sm={24}
            className="find-your-text"
          >
            <Space direction="vertical">
              {isTab1 ? (
                <></>
              ) : (
                <>
                  <BreadcrumbNav />
                </>
              )}
              <Text className="advertisement-txt">
                Where you are looking to advertise?
              </Text>
            </Space>
          </Col>
          <Col
            xl={12}
            lg={11}
            md={isTab ? 8 : 10}
            className="search-products-sh"
          >
            <Input
              className="search-input"
              value={searchInput}
              prefix={<SearchIcon />}
              allowClear
              onChange={handleSearchTextChange}
              placeholder="Search by product name..."
              disabled={isLoading}
              // className="products-page-row-input "
            />
          </Col>
        </Row>
        <Row>{!isTab1 && <Divider className="border-line-sh" />}</Row>
        {isTab1 && (
          <div className="mobile-view-filter-container">
            <Row className="product-page-row">
              <Space>
                <Button
                  className="filter-btn"
                  onClick={() => setDrawerVisible(true)}
                >
                  <Image
                    className="filter-img"
                    preview={false}
                    src={FilterSvg}
                    alt="filter"
                    height={20}
                    width={20}
                  />
                  Filters
                </Button>
                <Badge
                  count={total}
                  className="filters-count-badge"
                  style={{ backgroundColor: "#d2042d" }}
                />
                {filterProducts?.products?.[0]?.products_total_count > 0 ? (
                  <Text className="product-availble-count">
                    We found {filterProducts.products[0]?.products_total_count}{" "}
                    Products for you
                  </Text>
                ) : (
                  <Text className="product-availble-count">{""}</Text>
                )}
              </Space>
            </Row>
            <Row>
              <FilterDrawer
                ref={filterDrawerRef}
                visible={drawVisible}
                handleFiltersApplied={handleFiltersApplied}
                onClose={() => setDrawerVisible(false)}
                totalProductCount={
                  filterProducts?.products?.[0]?.products_total_count
                }
                setProductsMsg={setProductsMsg}
              />
            </Row>
            <Row style={{ paddingTop: 10 }}>
              <Input
                className="search-input"
                value={searchInput}
                onChange={handleSearchTextChange}
                placeholder="Search by product name..."
                disabled={isLoading}
                allowClear
              />
            </Row>
            <Row style={{ paddingTop: 10 }} align="middle">
              <Col span={12} className="location-card">
                <Card className="location-det-card">
                  <Row justify="start" align="middle">
                    <Col span={3}>
                      <Image
                        src={LocationIcon}
                        preview={false}
                        height={23}
                        width={23}
                      />
                    </Col>
                    <Col span={21}>
                      <div className="current-loc-text">Current location</div>
                      <WidthAwareTooltip title={currentLocation} width={150}>
                        <div className="location-text loc-truncate">
                          {currentLocation}
                        </div>
                      </WidthAwareTooltip>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={12}>
                <Row align="middle">
                  <Col span={14} offset={1}>
                    <Row justify="start" align="middle">
                      <Text className="toggle-filters">Nearby Products</Text>
                    </Row>
                    <Row justify="start" align="middle">
                      <Switch
                        checked={showNearby}
                        onChange={handleNearbyProducts}
                      />
                    </Row>
                  </Col>
                  <Col span={8}>
                    <Row justify="end" align="middle">
                      <Text className="toggle-filters">Map View</Text>
                    </Row>
                    <Row justify="end" align="middle">
                      <Switch checked={mapView} onChange={handleMapView} />
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
        <div>
          <Row className="filter-section">
            {mapView ? (
              <div>
                <Row className="selector-section" align="middle">
                  <Col xl={2}>
                    <div className="tab-filter-section">
                      <Space size={4}>
                        <span>
                          <Image
                            className="filter-img"
                            preview={false}
                            src={FilterSvg}
                            alt="filter"
                            height={24}
                            width={24}
                          />
                        </span>
                        <span>
                          <Text className="filter-txt" strong>
                            Filters
                            <Badge
                              count={total}
                              className="filters-count-badge"
                              style={{ backgroundColor: "#d2042d" }}
                            />
                          </Text>
                        </span>
                      </Space>
                    </div>
                  </Col>
                  <Col xl={16} md={14}>
                    <div className="select-filter-section">
                      <Row>
                        <ProductFilters
                          showNearby={showNearby}
                          location={location}
                          setSearchText={setSearchText}
                          searchText={searchText}
                          onFilterPayload={captureProductFilterPayload}
                        />
                        {mapView &&
                          (userInteracted || filterApplied) &&
                          !isLoading &&
                          (filterProducts?.products?.length ?? 0) > 0 && (
                            <Button
                              type="primary"
                              onClick={() => handleInstantCampaign()}
                              className="create-campaign-bulk-btn"
                              style={{ marginLeft: "10px" }}
                            >
                              Create Instant Campaign
                            </Button>
                          )}
                      </Row>
                    </div>
                  </Col>

                  <Col xl={6} md={8} className="toggle-filter-section">
                    <Space>
                      <Text className="toggle-filters">Nearby Products</Text>
                      <Switch
                        checked={showNearby}
                        onChange={handleNearbyProducts}
                      />
                      <Text className="toggle-filters">Map View</Text>
                      <Switch checked={mapView} onChange={handleMapView} />
                    </Space>
                  </Col>
                </Row>
                <div style={{ height: "66vh" }}>
                  <Row align="middle" justify="center">
                    {!isTab1 &&
                    filterProducts?.products?.[0]?.products_total_count > 0 ? (
                      <Text className="product-availble-count">
                        We found{" "}
                        {filterProducts?.products[0]?.products_total_count}{" "}
                        Products for you
                      </Text>
                    ) : (
                      <Text className="product-availble-count">{""}</Text>
                    )}
                  </Row>
                  <Row>
                    <Col xl={8} md={isTab1 ? 0 : 10} sm={0}>
                      <div className="map-view-section">
                        {userInteracted || (filterApplied && !isLoading) ? (
                          <>
                            <MobileProductCard
                              className="map-view"
                              isMapView={mapView}
                              currentPageData={
                                filterProducts?.products?.length
                                  ? filterProducts.products
                                  : []
                              }
                              handleProductSelect={handleProductSelect}
                              selectedProductId={selectedProductId}
                              isLoding={isLoading}
                            />

                            <Row justify="center" style={{ marginTop: 10 }}>
                              {!showNearby && (
                                <Pagination
                                  current={pageNum}
                                  pageSize={itemsPerPage}
                                  total={productsCount?.current?.[0]}
                                  onChange={(page) => {
                                    dispatch(setPagination(page));
                                    sessionStorage.setItem(
                                      "PAGINATION_ACTIVE",
                                      "true",
                                    );
                                  }}
                                  showSizeChanger={false}
                                />
                              )}
                            </Row>
                          </>
                        ) : (
                          <EmptyViewCard
                            header={
                              "Select an state on the map to filter products"
                            }
                            text={
                              "Your perfect placement might be just outside this view. Adjust filters or zoom out to uncover more OOH advertising opportunities."
                            }
                            state={true}
                          />
                        )}
                      </div>
                    </Col>
                    <Col xl={16} md={isTab1 ? 24 : 14} sm={24}>
                      <div className="product-page-maps">
                        <GoogleMapsComponent
                          location={location}
                          currentPageData={
                            filterProducts?.products ||
                            allFetchedProducts?.length
                              ? allFetchedProducts
                              : []
                          }
                          showNearby={showNearby}
                          onProductSelect={handleProductSelect}
                          selectedProductId={selectedProductId}
                          mapPinPointers={mapPinPointers}
                          productsTotalCount={products_total_count}
                          mapPinCount={map_pins_count}
                          isLoading={isLoading}
                          className="google-class"
                          onFilterPayload={captureProductFilterPayload}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : (
              <>
                <Col xl={5} md={0} sm={0} style={{ paddingLeft: "4rem" }}>
                  <Card className="filter-section-card">
                    <div className="filtersection-pad">
                      <Row justify="start">
                        <Col>
                          <Space>
                            <Image
                              className="filter-img"
                              preview={false}
                              src={FilterSvg}
                              alt="filter"
                              height={24}
                              width={24}
                            />
                            <Text className="filter-txt" strong>
                              Filters
                            </Text>
                            <Badge
                              count={total}
                              className="filters-count-badge"
                              style={{ backgroundColor: "#d2042d" }}
                            />
                          </Space>
                        </Col>
                      </Row>
                    </div>
                    <hr />
                    <div className="filtersection-pad">
                      <Row justify="center" align="middle">
                        <Col span={12}>
                          <Space>
                            {total > 0 && (
                              <Text className="filter-txt" strong>
                                Applied Filters
                              </Text>
                            )}
                          </Space>
                        </Col>
                        <Col span={12}>
                          <Button
                            type="link"
                            className="filter-reset-btn"
                            onClick={handleClearAll}
                          >
                            Clear all
                          </Button>
                        </Col>
                      </Row>

                      <Row>{tags}</Row>
                    </div>
                    <div>
                      <Collapse
                        bordered={false}
                        className="collapse-container-product"
                        expandIconPosition="end"
                        expandIcon={({ isActive }) =>
                          isActive ? (
                            <MinusOutlined
                              style={{ fontSize: 20, color: "#000" }}
                            />
                          ) : (
                            <PlusOutlined
                              style={{ fontSize: 20, color: "#000" }}
                            />
                          )
                        }
                      >
                        <Panel
                          header={
                            <span style={{ fontFamily: "Roboto" }}>
                              Dates
                              {selectedDateRange?.from &&
                                selectedDateRange?.to && (
                                  <Badge
                                    count={1}
                                    style={{ backgroundColor: "#d2042d" }}
                                    className="filters-count-badge"
                                  />
                                )}
                            </span>
                          }
                          className="collapse-pannel-container"
                          key="3"
                        >
                          <Row className="filter-date-picker">
                            <Col span={12}>
                              <DatePicker
                                bordered={false}
                                placeholder="From"
                                suffixIcon={<CalenderIcon />}
                                value={
                                  selectedDateRange?.from
                                    ? dayjs(
                                        selectedDateRange?.from,
                                        "YYYY-MM-DD",
                                      )
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange([
                                    date,
                                    selectedDateRange?.to,
                                  ])
                                }
                                popupClassName="end-date-calendar"
                              />
                            </Col>
                            <Col span={12}>
                              <DatePicker
                                bordered={false}
                                placeholder="To"
                                suffixIcon={<CalenderIcon />}
                                value={
                                  selectedDateRange?.to
                                    ? dayjs(selectedDateRange?.to, "YYYY-MM-DD")
                                    : null
                                }
                                onChange={(date) =>
                                  handleDateChange([
                                    selectedDateRange?.from,
                                    date,
                                  ])
                                }
                                popupClassName="end-date-calendar"
                              />
                            </Col>
                          </Row>
                          <Row justify="end">
                            <Button
                              onClick={() => {
                                if (
                                  !selectedDateRange?.from &&
                                  !selectedDateRange?.to
                                ) {
                                  return;
                                }
                                handleFetchProducts(1, true);
                              }}
                              className="filters-apply-btn"
                            >
                              <Text style={{ fontSize: 14, color: "#fff" }}>
                                Apply
                              </Text>
                            </Button>
                          </Row>
                        </Panel>
                        <Panel
                          header={
                            <span style={{ fontFamily: "Roboto" }}>
                              Location or DMA{" "}
                              <Badge
                                count={dmaCount}
                                style={{ backgroundColor: "#d2042d" }}
                                className="filters-count-badge"
                              />
                            </span>
                          }
                          className="collapse-pannel-container"
                          key="1"
                        >
                          {/* un implemented search input for locations */}
                          <Input
                            placeholder="Search for Locations"
                            variant="filled"
                            className="search-f-loc"
                            prefix={<SearchIcon />}
                            style={{ height: 40, marginBottom: "8px" }}
                            allowClear
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                          />

                          <div>
                            <Checkbox.Group
                              options={filteredLocationList
                                ?.slice(0, 5)
                                ?.map(({ id, city_name, product_count }) => ({
                                  label: (
                                    <span className="collapse-pannel-checkbox-label">
                                      {city_name}{" "}
                                      <span className="filter-products-count">
                                        ({product_count})
                                      </span>
                                    </span>
                                  ),
                                  value: JSON.stringify({ id, city_name }),
                                }))}
                              value={selectedDMAs?.map((loc) =>
                                JSON.stringify({
                                  id: loc?.id,
                                  city_name: loc?.label,
                                }),
                              )}
                              onChange={(checkedValues) => {
                                dispatch(setFiltersApplied(true));
                                dispatch(clearSelectedState());
                                dispatch(clearSelectedStateId());
                                const updatedLocations = checkedValues?.map(
                                  (val) => {
                                    const { id, city_name } = JSON.parse(val);
                                    return { id, label: city_name };
                                  },
                                );
                                dispatch(setSelectedDMAs(updatedLocations));
                                dispatch(setFiltersApplied(true));
                              }}
                              className="collapse-pannel-checkbox"
                            />
                          </div>
                          <div>
                            <LocationsList
                              showNearby={showNearby}
                              exposeClearFunction={(fn) =>
                                (dmaClearRef.current = fn)
                              }
                              placement="productpage"
                            />
                          </div>
                        </Panel>
                        <Panel
                          header={
                            <span style={{ fontFamily: "Roboto" }}>
                              Product Type{" "}
                              <Badge
                                count={filterCount}
                                style={{ backgroundColor: "#d2042d" }}
                                className="filters-count-badge"
                              />
                            </span>
                          }
                          className="collapse-pannel-container"
                          key="2"
                        >
                          <Collapse
                            expandIcon={({ isActive }) =>
                              isActive ? <SelectUpIcon /> : <SelectDownIcon />
                            }
                            bordered={false}
                            className="collapse-container-productType"
                            expandIconPosition="end"
                          >
                            {channelData
                              ?.slice()
                              ?.sort((a, b) => a.title.localeCompare(b.title))
                              ?.map(({ id, title, filter, color_code }) => {
                                const isExpanded = expandedPanels[title];
                                // Individual search value for this type
                                const searchValue =
                                  searchProductTypeByTitle[title] || "";
                                // Filter logic per type
                                const filtered = filter?.filter(({ label }) =>
                                  label
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase()),
                                );
                                const displayedFilters = isExpanded
                                  ? filtered
                                  : filtered?.slice(0, 5);
                                return (
                                  <Panel
                                    header={
                                      <span className="collapse-pannel-checkbox-label">
                                        <span
                                          className="dot"
                                          style={{
                                            backgroundColor: color_code,
                                          }}
                                        />
                                        {title}

                                        {filterChecks?.[title]?.length > 0 && (
                                          <Badge
                                            count={filterChecks[title].length}
                                            style={{
                                              backgroundColor: "#d2042d",
                                            }}
                                            className="filters-count-badge"
                                          />
                                        )}
                                      </span>
                                    }
                                    className="collapse-pannel-container"
                                    key={id?.toString()}
                                  >
                                    <Input
                                      placeholder="Search Product Type"
                                      variant="filled"
                                      className="search-f-loc"
                                      prefix={<SearchIcon />}
                                      style={{
                                        height: 40,
                                        marginBottom: "8px",
                                      }}
                                      allowClear
                                      value={searchValue}
                                      onChange={(e) =>
                                        setSearchProductTypeByTitle((prev) => ({
                                          ...prev,
                                          [title]: e.target.value,
                                        }))
                                      }
                                    />
                                    <Checkbox.Group
                                      options={displayedFilters
                                        ?.slice()
                                        ?.sort((a, b) =>
                                          a.label.localeCompare(b.label),
                                        )
                                        ?.map(
                                          ({ id, label, product_count }) => ({
                                            label: (
                                              <>
                                                <span
                                                  className="dot"
                                                  style={{
                                                    backgroundColor: color_code,
                                                  }}
                                                />
                                                <span className="products-type-check-box-label-names">
                                                  {label}{" "}
                                                  <span className="filter-products-count">
                                                    ({product_count})
                                                  </span>
                                                </span>
                                              </>
                                            ),
                                            value: JSON?.stringify({
                                              id,
                                              label,
                                            }),
                                          }),
                                        )}
                                      value={
                                        filterChecks[title]?.map((item) =>
                                          typeof item === "string"
                                            ? item
                                            : JSON?.stringify(item),
                                        ) || []
                                      }
                                      onChange={(checkedValues) => {
                                        dispatch(setFiltersApplied(true));
                                        dispatch(
                                          setFilterChecks({
                                            ...filterChecks,
                                            [title]: checkedValues,
                                          }),
                                        );
                                      }}
                                      // onChange={(checkedValues) =>
                                      //   handleFilterChange(title, checkedValues)
                                      // }
                                      className="collapse-pannel-checkbox"
                                    />
                                    {filter?.length > 5 && (
                                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                      <a
                                        className="view-more-loc"
                                        onClick={() => handleViewMore(title)}
                                      >
                                        {isExpanded ? "View Less" : "View More"}
                                      </a>
                                    )}
                                  </Panel>
                                );
                              })}
                          </Collapse>
                        </Panel>

                        <Panel
                          header="Price"
                          className="collapse-pannel-container"
                          key="4"
                        >
                          <Row className="budget-input" gutter={[16, 16]}>
                            <Col span={12}>
                              <Form.Item name="income_from">
                                <Row>
                                  <Input
                                    className="price-filter-input-field"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    inputMode="decimal"
                                    pattern="[0-9]*"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    placeholder="From"
                                    value={inComeSliderValue[0]}
                                    onChange={(e) =>
                                      handleIncomeInputChange(0, e)
                                    }
                                    variant="underlined"
                                    prefix="$"
                                  />
                                </Row>
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item name="income_to">
                                <Row>
                                  <Input
                                    className="price-filter-input-field"
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    inputMode="decimal"
                                    pattern="[0-9]*"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    placeholder="To"
                                    value={inComeSliderValue[1]}
                                    onChange={(e) =>
                                      handleIncomeInputChange(1, e)
                                    }
                                    variant="filled"
                                    prefix="$"
                                  />
                                </Row>
                              </Form.Item>
                            </Col>
                          </Row>
                          <div className="slider-parent">
                            <Slider
                              range
                              value={inComeSliderValue}
                              min={minPrice}
                              max={maxPrice}
                              trackStyle={{ backgroundColor: "red" }}
                              tooltip={{ open: false }}
                              onChange={handleInComeSliderChange}
                            />
                          </div>
                          <Row justify="end">
                            <Button
                              onClick={() => {
                                dispatch(setFiltersApplied(true));
                                handleFetchProducts(1, true);
                              }}
                              className="filters-apply-btn"
                            >
                              <Text style={{ fontSize: 14, color: "#fff" }}>
                                Apply
                              </Text>
                            </Button>
                          </Row>
                        </Panel>
                        <Panel
                          header={
                            <span style={{ fontFamily: "Roboto" }}>
                              Size
                              {!selectedSizes == "" && (
                                <Badge
                                  count={selectedSizes?.length}
                                  style={{ backgroundColor: "#d2042d" }}
                                  className="filters-count-badge"
                                />
                              )}
                            </span>
                          }
                          className="collapse-pannel-container"
                          key="5"
                        >
                          <Checkbox.Group
                            options={sizeList?.map((item) =>
                              handleTextChange(item?.label),
                            )}
                            value={selectedSizes}
                            onChange={handleSelectedSizesChange}
                            className="collapse-pannel-checkbox"
                          />
                        </Panel>
                        <div style={{ marginTop: "20px" }}>
                          <AdPlacement
                            type="products"
                            position="left-bottom"
                            adUnitId={0}
                          />
                        </div>
                      </Collapse>
                    </div>
                  </Card>
                </Col>
                <Col xl={19} md={24} sm={24}>
                  <div>
                    <Row align="middle" className="products-list-subcontainer">
                      <Col span={1} className="location-icon-c">
                        <Image
                          src={LocationIcon}
                          alt="location-icon"
                          preview={false}
                        />
                      </Col>
                      <Col xl={7} md={8} className="location-text-col-tablet">
                        <div>
                          <Text className="location-text">
                            Current location{" "}
                          </Text>
                        </div>
                        <>
                          <Space className="address-section-space-tag">
                            <WidthAwareTooltip
                              title={currentLocation}
                              width={150}
                            >
                              <Text className="address-text loc-truncate">
                                {currentLocation}
                              </Text>
                            </WidthAwareTooltip>
                            {/* <Link type="link" className="change-btn-text">
                              Change
                            </Link> */}
                          </Space>
                        </>
                      </Col>
                      <Col xl={7} md={6}>
                        {filterProducts?.products?.[0]?.products_total_count >
                        0 ? (
                          <Text className="product-availble-count">
                            We found{" "}
                            {filterProducts.products[0]?.products_total_count}{" "}
                            Products for you
                          </Text>
                        ) : (
                          <Text className="product-availble-count">{""}</Text>
                        )}
                      </Col>
                      <Col xl={9} md={9} className="toggle-filter-section">
                        <Space>
                          <Segmented
                            value={viewType}
                            onChange={(val) => dispatch(setViewType(val))}
                            className="view-toggle-segment"
                            options={[
                              {
                                value: "kanban",
                                icon: (
                                  <AppstoreOutlined
                                    style={{ width: "20px", height: "auto" }}
                                  />
                                ),
                              },
                              { value: "list", icon: <BarsOutlined /> },
                            ]}
                          />
                          <Text className="toggle-filters">
                            Nearby Products
                          </Text>
                          <Switch
                            checked={showNearby}
                            onChange={handleNearbyProducts}
                          />
                          <Text className="toggle-filters">Map View</Text>
                          <Switch checked={mapView} onChange={handleMapView} />
                        </Space>
                      </Col>
                    </Row>
                    <div className="products-container">
                      <div className="products-list-container">
                        {isTab ? (
                          <Row
                            style={{ height: "70px" }}
                            className="selector-section"
                          >
                            <Col span={2}>
                              <div className="tab-filter-section">
                                <div>
                                  <Image
                                    className="filter-img"
                                    preview={false}
                                    src={FilterSvg}
                                    alt="filter"
                                    height={24}
                                    width={24}
                                  />
                                </div>
                                <div>
                                  <Text className="filter-txt">Filters</Text>
                                </div>
                              </div>
                            </Col>
                            <Col span={22}>
                              <div className="select-filter-section">
                                <Space>
                                  <ProductFilters
                                    searchText={searchText}
                                    showNearby={showNearby}
                                    location={location}
                                    filterChecks={filterChecks}
                                    onFilterPayload={
                                      captureProductFilterPayload
                                    }
                                  />
                                </Space>
                              </div>
                            </Col>
                          </Row>
                        ) : null}
                        <div className="cards-container">
                          {isTab1 ? (
                            <div>
                              <div
                                ref={containerRef}
                                style={{ overflowY: "scroll", height: "55vh" }}
                              >
                                <MobileProductCard
                                  currentPageData={
                                    allFetchedProducts?.length
                                      ? allFetchedProducts
                                      : []
                                  }
                                  selectedProductId={selectedProductId}
                                />
                                <Text>{productMsg}</Text>
                              </div>
                            </div>
                          ) : (
                            <>
                              {viewType === "list" ? (
                                <DesktopProductCard
                                  key="list-view"
                                  isMapView={mapView}
                                  currentPageData={
                                    filterProducts?.products?.length
                                      ? filterProducts.products
                                      : []
                                  }
                                />
                              ) : (
                                <>
                                  {viewType === "kanban" && (
                                    <ProductGridCard
                                      currentPageData={
                                        filterProducts?.products?.length
                                          ? filterProducts.products
                                          : []
                                      }
                                    />
                                  )}
                                </>
                              )}
                              <Row justify="end" className="pagination-cnt">
                                {!showNearby && !isTab1 && (
                                  <Pagination
                                    current={pageNum}
                                    pageSize={itemsPerPage}
                                    total={productsCount?.current?.[0]}
                                    // onChange={(page) =>
                                    //   dispatch(setPagination(page))
                                    // }
                                    onChange={(page) => {
                                      dispatch(setPagination(page));
                                      sessionStorage.setItem(
                                        "PAGINATION_ACTIVE",
                                        "true",
                                      );
                                    }}
                                    showSizeChanger={false}
                                  />
                                )}
                              </Row>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
      <ViewMoreFilter
        isOpen={isViewFilter}
        onClose={() => setIsViewFilter(false)}
        filters={filters}
        setFilters={setFilters}
        handleClose={handleClose}
        selectedDMAs={selectedDMAs}
        showNearby={showNearby}
        items={items}
      />
      <ReusableModal
        type="BulkCampaign"
        isActionModal={isBulkCampaignModalOpen}
        setIsActionModal={setIsBulkCampaignModalOpen}
        min_date={filterProducts?.filter_data?.min_date}
        max_date={filterProducts?.filter_data?.max_date}
        filterPayload={lastProductFilterPayload}
      />
      <LoginAlert
        loginPopoverVisible={loginPopoverVisible}
        setLoginPopoverVisible={setLoginPopoverVisible}
      />
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default ProductPage;
